import { Box, Typography } from "@mui/material";
import React from "react";
import { CustomDialog } from "../../../components/customDialog/CustomDialog";
import DataGridGenerico from "../../../components/dataGrid/DataGridGenerico";
import { useLogisticaDialogColumns } from "../hooks/useLogisticaDialogColumns";
import { useLogisticaDialogRows } from "../hooks/useLogisticaDialogRows";

export function LogisticaDialog({
  open,
  handleCloseDialog,
  idEvaluacion,
  data,
}) {
  const { paciente, hC } = data || {};

  const {
    resumenDietaRows,
    resumenContratoRows,
    resumenEnvioRows,
    loadingResumenDieta,
    loadingResumenContrato,
    loadingResumenEnvio,
  } = useLogisticaDialogRows(idEvaluacion);

  const { UMEcolumns, contratosColumns, enviosColumns } = useLogisticaDialogColumns();

  return (
    <CustomDialog
      title="Herramienta de programación de envíos"
      open={open}
      fullWidth
      maxWidth="md"
      onCancel={handleCloseDialog}
      cancelText="Cerrar"
    >
      <Box display="flex" gap="20px" mt="-12px">
        <p>Paciente: {paciente}</p>
        <p>HC: {hC}</p>
      </Box>
      <Box display="flex" flexDirection="column" gap="22px">
        <Box>
          <h4>Resumen UME Dieta vs UME Suministro</h4>
          <DataGridGenerico
            columns={UMEcolumns}
            rows={resumenDietaRows}
            loading={loadingResumenDieta}
            toolbar={false}
          />
        </Box>
        <Box>
          <h4>Resumen de contratos</h4>
          <DataGridGenerico
            columns={contratosColumns}
            rows={resumenContratoRows}
            loading={loadingResumenContrato}
            toolbar={false}
          />
        </Box>
        <Box>
          <h4>Detalle de envio</h4>
          <DataGridGenerico
            columns={enviosColumns}
            rows={resumenEnvioRows}
            loading={loadingResumenEnvio}
            toolbar={false}
          />
        </Box>
      </Box>
    </CustomDialog>
  );
}
